const rightHierarchy = {
    READ: ['READ', 'WRITE', 'ADMIN', 'SUPER_ADMIN'],
    WRITE: ['WRITE', 'ADMIN', 'SUPER_ADMIN'],
    ADMIN: ['ADMIN', 'SUPER_ADMIN'],
    SUPER_ADMIN: ['SUPER_ADMIN']
};
export class User {
    constructor(data) {
        Object.assign(this, data);
    }
    hasRight(required) {
        const effectiveRights = rightHierarchy[required] || [];
        return effectiveRights.includes(this.rights);
    }
}
